const state = {
    tkrWeek: '',
    tkrLeague: '',
    tkrSd: '',
    tkrNotices: '',
};

const getters = {
    tkrWeek(state) { return state.tkrWeek },
    tkrLeague(state) { return state.tkrLeague },
    tkrSd(state) { return state.tkrSd },
    tkrNotices(state) { return state.tkrNotices },
    messageLength(state) { return state.tkrWeek.length + state.tkrLeague.length + state.tkrSd.length }
};

const actions = {
    updateTkrWeek({ commit }, str) { commit('SET_TKR_WEEK', str)},
    updateTkrLeague({ commit }, str) { commit('SET_TKR_LEAGUE', str)},
    updateTkrSd({ commit }, str) { commit('SET_TKR_SD', str)},
    updateTkrNotices({ commit }, str) { commit('SET_TKR_NOTICES', str)},
};

const mutations = {
    SET_TKR_WEEK(state, str) { state.tkrWeek = str },
    SET_TKR_LEAGUE(state, str) { state.tkrLeague = str },
    SET_TKR_SD(state, str) { state.tkrSd = str },
    SET_TKR_NOTICES(state, str) { state.tkrNotices = str },
};


export default {
  state,
  getters,
  actions,
  mutations,
}
